import Attrs from '../../models/Attrs'
import type { FlowPage, OptionSelector } from '../../models/types'

export default function renderPageTitle(
  component: OptionSelector,
  attrs: Attrs,
  page: FlowPage
): string {
  const inPageClasses = [
    `in-page-key-${page.key}`,
    ...(page.tags || []).map((tag) => `in-page-tag-${tag}`),
  ]
  attrs.addDOMClass(['title', ...inPageClasses])
  attrs.addController('template')
  return `<div ${attrs}>${page.title || ''}</div>`
}
